export const ROUTE_PATH = '/clean/cleaner/binder' as const
